import React, { Component } from "react";
import "./App.css";
import MilesCalculator from "./MilesCalculator.js";

class App extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      price: ""
    };
  }

  handleChange(e) {
    this.setState({ price: e.target.value });
  }

  render() {
    const price = parseFloat(this.state.price);
    return (
      <div className="App">
        <div className="Price">
          <label htmlFor="price">Prix du billet avant taxes : </label>
          <input
            name="price"
            type="number"
            onChange={this.handleChange}
            value={price}
          />
        </div>
        <table>
          <thead>
            <tr>
              <th />
              <th>
                Ivory<br />
                <small>4 miles par euro</small>
              </th>
              <th>
                Silver<br />
                <small>5 miles par euro</small>
              </th>
              <th>
                Gold<br />
                <small>7 miles par euro</small>
              </th>
              <th>
                Platinum<br />
                <small>8 miles par euro</small>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Gain de miles</th>
              <td>
                <MilesCalculator multiplier="4" price={price} />
              </td>
              <td>
                <MilesCalculator multiplier="5" price={price} />
              </td>
              <td>
                <MilesCalculator multiplier="7" price={price} />
              </td>
              <td>
                <MilesCalculator multiplier="8" price={price} />
              </td>
            </tr>
            <tr>
              <th>Bonus lié au statut *</th>
              <td>
                <div className="CellDisplay">0%</div>
              </td>
              <td>
                <div className="CellDisplay">50%</div>
              </td>
              <td>
                <div className="CellDisplay">75%</div>
              </td>
              <td>
                <div className="CellDisplay">100%</div>
              </td>
            </tr>
            <tr>
              <th>Gain total de miles **</th>
              <td>
                <MilesCalculator multiplier="4" price={price} />
              </td>
              <td>
                <MilesCalculator multiplier="5" bonus="0.5" price={price} />
              </td>
              <td>
                <MilesCalculator multiplier="7" bonus="0.75" price={price} />
              </td>
              <td>
                <MilesCalculator multiplier="8" bonus="1" price={price} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js